// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"08736a6d","568":"0713c011"}[chunkId] + ".chunk.js";
};